
export function convertExcelDate(value: any) {
    const num = ((+value - (25567 + 2)) * 86400 * 1000)
    return new Date(num);
}